export const GENDER_QUESTION = 'Select your gender'
export const SECTION_NUMBER = 1

export const GENDER_OPTIONS = [
  { key: 'male', emoji: '👨', i18nKey: 'onboarding.gender.options.first' },
  { key: 'female', emoji: '👩', i18nKey: 'onboarding.gender.options.second' },
  { key: 'other', emoji: '✋', i18nKey: 'onboarding.gender.options.third' },
] as const
